var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLinkedinFilled(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "100%",
    height: "100%",
    viewBox: "0 0 26.03 26.03",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "\\u7EC4_745",
    "data-name": "\\u7EC4 745",
    transform: "translate(-1862 -1046.915)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "\\u8DEF\\u5F84_343",
    "data-name": "\\u8DEF\\u5F84 343",
    d: "M1874.2,1046.915h1.627a1.343,1.343,0,0,0,.2.041,12.4,12.4,0,0,1,5.653,1.8,12.848,12.848,0,0,1,6.154,8.933c.088.473.134.953.2,1.43v1.626c-.021.167-.044.334-.062.5a13.047,13.047,0,0,1-10.686,11.5c-.481.087-.969.135-1.453.2H1874.2c-.318-.039-.636-.073-.953-.118A13.045,13.045,0,0,1,1862.2,1062.2c-.087-.481-.136-.97-.2-1.455v-1.626c.021-.167.043-.334.061-.5a13.043,13.043,0,0,1,10.737-11.505C1873.263,1047.03,1873.734,1046.98,1874.2,1046.915Zm1.953,19.666c0-.819,0-1.614,0-2.409,0-1.076,0-2.152.023-3.227a1.634,1.634,0,0,1,.8-1.346,1.525,1.525,0,0,1,2.375.855,4.246,4.246,0,0,1,.135,1.1c.014,1.584.006,3.168.006,4.752v.265h3.158c0-.083.01-.15.01-.217,0-1.736,0-3.473,0-5.209a9,9,0,0,0-.067-1.038,3.4,3.4,0,0,0-3.138-3.252,3.154,3.154,0,0,0-3.164,1.357,1.839,1.839,0,0,1-.132.142c0-.393-.01-.729,0-1.065.007-.188-.05-.248-.243-.246-.906.009-1.812,0-2.719.005-.065,0-.13.013-.193.019v9.512Zm-4.932,0c.006-.065.013-.106.013-.147q0-4.587,0-9.175c0-.2-.088-.215-.246-.214-.9.005-1.8,0-2.694,0-.074,0-.147.011-.221.017v9.516Zm-3.342-12.476a1.644,1.644,0,0,0,1.771,1.647,1.653,1.653,0,1,0,.024-3.3A1.65,1.65,0,0,0,1867.881,1054.107Z",
    fill: "currentColor"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLinkedinFilled);
export default __webpack_public_path__ + "static/media/linkedin_filled.f5206cf0f8e3769e979381c1a48a55d5.svg";
export { ForwardRef as ReactComponent };